import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ProductDetails, ProductResponse, ProductListResponse } from '../models/product.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';


@Injectable()
export class ProductService {
    private baseUrl: string;
    private api: string = "api/Product";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Product Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

    async getProductAsync(encryptedUser: string, productId: number, countryID: number, contractType: string): Promise<ProductResponse | void> {
        const a = await this.httpClient
            .get<ProductResponse>(`${this.baseUrl}/GetProduct/${productId}/${countryID}/${contractType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "productId - " + productId, encryptedUser, "ProductService", "getProductAsync"); });


        return a;
    }

    async getProductListAsync(encryptedUser: string, inventionId: number, countryID: number, contractType: string): Promise<ProductListResponse | void> {
        const a = await this.httpClient
            .get<ProductListResponse>(`${this.baseUrl}/GetProductList/${inventionId}/${countryID}/${contractType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, encryptedUser, "ProductService", "getProductListAsync"); });


        return a;
    }
}
